import React, { memo, useMemo } from "react"
import {
    Grid,
    makeStyles,
} from "@material-ui/core"
import { Form, Formik } from "formik"
import * as yup from "yup"
import { useLocalization } from "@fluent/react"
import { LocalizedStrict } from "../../../Localization/Components/Localized"
import { FormikSelectControl, FormikTextField } from "../../../../Components/Form/Formik"

import {
    IDeliveryForm,
    IDeliveryFormProps,
} from "../../../../Types/MeetingPlanning/deliveryForm"
import DeliveryTypeFormSection from "../Layouts/DeliveryTypeFormSection"
import { SubmitButton } from "../Layouts/SubmitButton"
import {
    deliveryFormSchema,
    initialDeliveryFormSchema,
    initialDeliveryFormValues,
    deliveryFormValues,
    TEXT_FIELD_MAX_LENGTH,
    SELECT_OPTIONS,
} from "../../../../Static/MeetingPlanning/deliveryForm"

const useDeliveryFormStyles = makeStyles((theme) => ({
    mr_2: {
        marginRight: theme.spacing(2),
    },
    mb_2: {
        marginBottom: theme.spacing(2),
    },
}))

const DeliveryForm = ({ isInitialShow, initialDeliveryForm, currentMeetingPlaningDelivery, userCanteenId, onSubmit }: IDeliveryFormProps) => {
    const classes = useDeliveryFormStyles()
    const { l10n } = useLocalization()

    const deliverySelectOptions = useMemo(() => SELECT_OPTIONS.map((item) => ({ ...item, label: l10n.getString(item.label) })), [l10n, SELECT_OPTIONS])

    const validationSchema = yup.object().shape({
        ...initialDeliveryFormSchema(l10n),
        ...deliveryFormSchema(l10n),
    })

    const handleSubmit = (formValues: IDeliveryForm) => {
        onSubmit?.(formValues)
    }

    return <Formik<IDeliveryForm>
        initialValues={{
            ...initialDeliveryFormValues(initialDeliveryForm || null),
            ...deliveryFormValues(currentMeetingPlaningDelivery?.formFields || null)
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
    >
        <Form>
            <Grid item container direction="column" wrap="nowrap" justifyContent="flex-start">
                {isInitialShow ? <>
                    <Grid item className={classes.mb_2}>
                        <LocalizedStrict id="delivery-form-meeting-field-label" attrs={{ label: true }}>
                            <FormikTextField<IDeliveryForm>
                                name="meetingName"
                                inputProps={{ maxLength: TEXT_FIELD_MAX_LENGTH }}
                                variant="outlined"
                                fullWidth
                                label="Mødenavn"
                            />
                        </LocalizedStrict>
                    </Grid>
                    <Grid item className={classes.mb_2}>
                        <LocalizedStrict id="delivery-form-delivery-type-field-label" attrs={{ label: true }}>
                            <FormikSelectControl name="deliveryType" label="Leveringstype" options={deliverySelectOptions}/>
                        </LocalizedStrict>
                    </Grid>
                </> : null}

                <DeliveryTypeFormSection
                    userCanteenId={userCanteenId}
                    isInitialShow={isInitialShow}
                />

                <SubmitButton />
            </Grid>
        </Form>
    </Formik>
}

export default memo(DeliveryForm)
